import React from "react";
import { NavLink } from "react-router-dom";
const links = [{
  to: "/organizer/draw/subjects",
  label: "Track draw"
}, {
  to: "/organizer/draw/teams",
  label: "Name draw"
}];
export function DrawNav() {
  return <nav aria-label="Draws" className="inline-flex rounded-xl bg-ink/5 p-1" data-id="element-112" data-mp="v5ka6h8mphnn">
      {links.map(link => <NavLink key={link.to} to={link.to} end className={({
      isActive
    }) => `whitespace-nowrap rounded-lg px-4 py-2 text-sm font-semibold transition-colors duration-150 ${isActive ? "bg-surface text-ink shadow-sm" : "text-muted hover:text-ink"}`} data-id="element-113" data-mp="z6w3awqpol0l">
          {link.label}
        </NavLink>)}
    </nav>;
}